<template>
    <div class="org-dashboard font-web">
        <!-- Header -->
        <div class="org-dashboard-header">
            <h2 class="org-dashboard-title">Mahidol University International College HRM - Workforce overview</h2>
            <div class="org-header-actions">
                <span class="org-header-date">
                    <a-icon type="calendar" style="margin-right: 6px; color: #1890ff;" />
                    Data as of August 2026
                </span>
            </div>
        </div>

        <!-- Stat Cards Row -->
        <div class="org-stat-grid">
            <!-- Number of MUIC Staff -->
            <div class="org-stat-card">
                <div class="org-stat-card-header">
                    <div class="org-stat-icon-wrap org-stat-icon-staff">
                        <a-icon type="team" />
                    </div>
                    <span class="org-stat-label">Number of MUIC Staff</span>
                    <a-icon type="info-circle" class="org-stat-info" />
                </div>
                <div class="org-stat-value-wrap">
                    <span class="org-stat-value">415</span>
                </div>
            </div>

            <!-- Thai Staff -->
            <div class="org-stat-card">
                <div class="org-stat-card-header">
                    <div class="org-stat-icon-wrap org-stat-icon-thai">
                        <a-icon type="user" />
                    </div>
                    <span class="org-stat-label">Thai Staff</span>
                    <a-icon type="info-circle" class="org-stat-info" />
                </div>
                <div class="org-stat-value-wrap">
                    <span class="org-stat-value">351</span>
                </div>
            </div>

            <!-- Foreigner Staff -->
            <div class="org-stat-card">
                <div class="org-stat-card-header">
                    <div class="org-stat-icon-wrap org-stat-icon-foreign">
                        <a-icon type="global" />
                    </div>
                    <span class="org-stat-label">Foreigner Staff</span>
                    <a-icon type="info-circle" class="org-stat-info" />
                </div>
                <div class="org-stat-value-wrap">
                    <span class="org-stat-value">64</span>
                </div>
            </div>

            <!-- Sections -->
            <div class="org-stat-card">
                <div class="org-stat-card-header">
                    <div class="org-stat-icon-wrap org-stat-icon-sections">
                        <a-icon type="appstore" />
                    </div>
                    <span class="org-stat-label">Sections</span>
                    <a-icon type="info-circle" class="org-stat-info" />
                </div>
                <div class="org-stat-value-wrap">
                    <span class="org-stat-value">21</span>
                </div>
            </div>

            <!-- Divisions / Center -->
            <div class="org-stat-card">
                <div class="org-stat-card-header">
                    <div class="org-stat-icon-wrap org-stat-icon-divisions">
                        <a-icon type="bank" />
                    </div>
                    <span class="org-stat-label">Divisions / Center</span>
                    <a-icon type="info-circle" class="org-stat-info" />
                </div>
                <div class="org-stat-value-wrap">
                    <span class="org-stat-value">6 Div / 1 Ctr</span>
                </div>
            </div>
        </div>

        <!-- Charts Row -->
        <a-row type="flex" :gutter="[20, 20]" class="org-chart-row">
            <!-- Sales Overview -->
            <a-col :xs="24" :lg="16">
                <div class="org-chart-card">
                    <div class="org-chart-card-header">
                        <div>
                            <div class="org-chart-title-wrap">
                                <a-icon type="bar-chart" class="org-chart-title-icon" />
                                <span class="org-chart-title">Headcount by Department</span>
                            </div>
                            <div class="org-chart-big-value">{{ totalHeadcount }} </div>
                            <!--  
                                <div class="org-chart-sub">
                                    <span class="org-stat-badge org-badge-up" style="font-size: 12px;">2.4% <a-icon
                                            type="arrow-up" /></span>
                                    <span class="org-chart-sub-text">+ 18  จากปีที่แล้ว</span>
                                </div>
                            -->
                        </div>
                    </div>
                    <apexchart type="bar" height="550" :options="salesOverviewOptions" :series="salesOverviewSeries" />
                </div>
            </a-col>

            <!-- Staff Type Distribution -->
            <a-col :xs="24" :lg="8">
                <div class="org-chart-card">
                    <div class="org-chart-card-header">
                        <div>
                            <div class="org-chart-title-wrap">
                                <a-icon type="team" class="org-chart-title-icon" />
                                <span class="org-chart-title">Staff Type Distribution</span>
                            </div>
                            <div class="org-chart-big-value">415 </div>
                            <div class="org-chart-sub">
                                <span class="org-chart-sub-text">Total academic & support staff</span>
                            </div>
                        </div>
                    </div>
                    <div style="flex: 1; display: flex; align-items: center; justify-content: center;">
                        <apexchart type="pie" width="100%" height="320" :options="staffTypeDistributionOptions"
                            :series="staffTypeDistributionSeries" />
                    </div>
                    <a-table :columns="staffTypeColumns" :data-source="staffTypeTableData" :pagination="false"
                        class="org-staff-type-table" size="small" :bordered="false" rowKey="staffType">
                    </a-table>
                </div>
            </a-col>
        </a-row>

        <!-- Bottom Row -->
        <a-row type="flex" :gutter="[20, 20]" class="org-bottom-row">
            <!-- Sales Distribution -->
            <!-- Gender Distribution -->
            <a-col :xs="24" :lg="7">
                <div class="org-chart-card">
                    <div class="org-chart-card-header">
                        <div class="org-chart-title-wrap">
                            <a-icon type="pie-chart" class="org-chart-title-icon" />
                            <span class="org-chart-title">Gender</span>
                        </div>
                    </div>
                    <div class="org-distribution-stats">
                        <div class="org-dist-item">
                            <span class="org-dist-indicator" style="background: #6C5DD3;"></span>
                            <span class="org-dist-label">ชาย (Male)</span>
                            <span class="org-dist-value">{{ genderDistributionData.male }} </span>
                        </div>
                        <div class="org-dist-item">
                            <span class="org-dist-indicator" style="background: #3DD9C1;"></span>
                            <span class="org-dist-label">หญิง (Female)</span>
                            <span class="org-dist-value">{{ genderDistributionData.female }} </span>
                        </div>
                    </div>
                    <apexchart type="donut" height="240" :options="distributionOptions" :series="distributionSeries" />
                </div>
            </a-col>

            <!-- Generation -->
            <a-col :xs="24" :lg="7">
                <div class="org-chart-card">
                    <div class="org-chart-card-header">
                        <div class="org-chart-title-wrap">
                            <a-icon type="pie-chart" class="org-chart-title-icon" />
                            <span class="org-chart-title">Generation</span>
                        </div>
                    </div>
                    <div class="org-distribution-stats">
                        <div class="org-dist-item">
                            <span class="org-dist-indicator" style="background: #6C5DD3;"></span>
                            <span class="org-dist-label">Gen X</span>
                            <span class="org-dist-value">{{ generationDistributionData.genX }} </span>
                        </div>
                        <div class="org-dist-item">
                            <span class="org-dist-indicator" style="background: #3DD9C1;"></span>
                            <span class="org-dist-label">Gen Y</span>
                            <span class="org-dist-value">{{ generationDistributionData.genY }} </span>
                        </div>
                        <div class="org-dist-item">
                            <span class="org-dist-indicator" style="background: #FF754C;"></span>
                            <span class="org-dist-label">Gen Z</span>
                            <span class="org-dist-value">{{ generationDistributionData.genZ }} </span>
                        </div>
                        <div class="org-dist-item">
                            <span class="org-dist-indicator" style="background: #FFD043;"></span>
                            <span class="org-dist-label">Baby Boomer</span>
                            <span class="org-dist-value">{{ generationDistributionData.babyBoomer }} </span>
                        </div>
                    </div>
                    <apexchart type="donut" height="240" :options="generationOptions" :series="generationSeries" />
                </div>
            </a-col>

            <!-- Top Nationalities -->
            <a-col :xs="24" :lg="10">
                <div class="org-chart-card">
                    <div class="org-chart-card-header">
                        <div class="org-chart-title-wrap">
                            <a-icon type="global" class="org-chart-title-icon" />
                            <span class="org-chart-title">Top Nationalities</span>
                        </div>
                    </div>
                    <apexchart type="bar" height="420" :options="nationalityOptions" :series="nationalitySeries" />
                </div>
            </a-col>
        </a-row>
    </div>
</template>

<script>
import moment from "moment";
import { HR as originalHR } from "./datahrm/hrm";
const HR = originalHR || [];

export default {
    name: "OrganizationData",
    data() {
        return {
            dateRange: [moment().subtract(1, "months"), moment()],
            staffTypeColumns: [
                {
                    title: "Staff Type Distribution",
                    dataIndex: "staffType",
                    key: "staffType",
                },
                {
                    title: "ชาย (Male)",
                    dataIndex: "male",
                    key: "male",
                    align: "right",
                },
                {
                    title: "หญิง (Female)",
                    dataIndex: "female",
                    key: "female",
                    align: "right",
                },
            ],


            // Staff Type Distribution Chart
            staffTypeDistributionOptions: {
                chart: {
                    id: "staff-type-distribution",
                    type: "pie",
                    fontFamily: "Sarabun, sans-serif",
                    toolbar: { show: false },
                },
                plotOptions: {
                    pie: {
                        customScale: 0.95,
                    },
                },
                labels: ["Supporting Staff", "Lecturer", "Assistant Lecturer", "Instructor"],
                colors: ["#6C5DD3", "#3DD9C1", "#FF754C", "#FFD043"],
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val.toFixed(1) + "%";
                    },
                    style: {
                        fontSize: "14px",
                        fontFamily: "Sarabun, sans-serif",
                        fontWeight: "bold",
                    },
                },
                legend: {
                    position: "bottom",
                    horizontalAlign: "center",
                    fontSize: "13px",
                    markers: { radius: 3 },
                    labels: { colors: "#8F95B2" },
                    itemMargin: { horizontal: 8, vertical: 4 },
                },
                tooltip: {
                    y: {
                        formatter: (val) => `${val} `,
                    },
                },
            },
            staffTypeDistributionSeries: [262, 125, 17, 11],




        };
    },
    computed: {
        totalHeadcount() {
            return HR.length;
        },
        staffTypeTableData() {
            const categories = ['Supporting Staff', 'Lecturer', 'Assistant Lecturer', 'Instructor'];
            const counts = {};
            categories.forEach(cat => {
                counts[cat] = { male: 0, female: 0 };
            });

            HR.forEach(employee => {
                const type = employee.muic_staff_type;
                const gender = employee.gender;
                if (categories.includes(type)) {
                    if (gender === 'Male') {
                        counts[type].male++;
                    } else if (gender === 'Female') {
                        counts[type].female++;
                    }
                }
            });

            return categories.map(cat => ({
                staffType: cat,
                male: counts[cat].male,
                female: counts[cat].female
            }));
        },
        departmentHeadcountData() {
            const counts = {};
            HR.forEach(employee => {
                const dept = employee.department || "Unknown";
                const gender = employee.gender || "Unknown";

                if (!counts[dept]) {
                    counts[dept] = { total: 0, Male: 0, Female: 0 };
                }

                counts[dept].total += 1;
                if (gender === "Male") {
                    counts[dept].Male += 1;
                } else if (gender === "Female") {
                    counts[dept].Female += 1;
                }
            });

            // Sort by total headcount descending
            const sortedDepts = Object.keys(counts)
                .map(dept => ({
                    name: dept,
                    total: counts[dept].total,
                    male: counts[dept].Male,
                    female: counts[dept].Female
                }))
                .sort((a, b) => b.total - a.total);

            return {
                categories: sortedDepts.map(d => d.name),
                maleSeries: sortedDepts.map(d => d.male),
                femaleSeries: sortedDepts.map(d => d.female)
            };
        },
        salesOverviewSeries() {
            return [
                {
                    name: "ชาย",
                    data: this.departmentHeadcountData.maleSeries
                },
                {
                    name: "หญิง",
                    data: this.departmentHeadcountData.femaleSeries
                }
            ];
        },
        salesOverviewOptions() {
            return {
                chart: {
                    id: "sales-overview",
                    type: "bar",
                    stacked: true,
                    toolbar: { show: false },
                    fontFamily: "Sarabun, sans-serif",
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: "70%",
                        borderRadius: 4,
                        dataLabels: {
                            total: {
                                enabled: true,
                                offsetX: 8,
                                style: {
                                    color: "#555770",
                                    fontSize: "13px",
                                    fontFamily: "Sarabun, sans-serif",
                                    fontWeight: "bold",
                                }
                            }
                        }
                    },
                },
                dataLabels: {
                    enabled: true,
                    textAnchor: "start",
                    style: {
                        colors: ["#fff"],
                        fontSize: "13px",
                        fontFamily: "Sarabun, sans-serif",
                        fontWeight: "bold",
                    },
                    formatter: function (val) {
                        return val > 0 ? val : "";
                    },
                    offsetX: 0,
                },
                xaxis: {
                    categories: this.departmentHeadcountData.categories,
                    labels: {
                        style: { colors: "#8F95B2", fontSize: "13px" },
                    },
                    axisBorder: { show: false },
                    axisTicks: { show: false },
                },
                yaxis: {
                    labels: {
                        style: { colors: "#8F95B2", fontSize: "13px" },
                        maxWidth: 300,
                    },
                },
                grid: {
                    borderColor: "#F0F0F5",
                    xaxis: { lines: { show: true } },
                    yaxis: { lines: { show: false } },
                },
                colors: ["#6C5DD3", "#3DD9C1"],
                legend: {
                    show: true,
                    position: "bottom",
                    horizontalAlign: "center",
                    fontSize: "13px",
                    markers: { radius: 3 },
                    labels: { colors: "#8F95B2" },
                    itemMargin: { horizontal: 12, vertical: 5 },
                },
                tooltip: {
                    y: {
                        formatter: (val) => `${val} `,
                    },
                },
            };
        },
        genderDistributionData() {
            let maleCount = 0;
            let femaleCount = 0;
            HR.forEach(employee => {
                if (employee.gender === "Male") {
                    maleCount++;
                } else if (employee.gender === "Female") {
                    femaleCount++;
                }
            });
            return {
                male: maleCount,
                female: femaleCount,
                total: maleCount + femaleCount
            };
        },
        distributionSeries() {
            return [this.genderDistributionData.male, this.genderDistributionData.female];
        },
        distributionOptions() {
            return {
                chart: {
                    type: "donut",
                    fontFamily: "Sarabun, sans-serif",
                },
                labels: ["ชาย (Male)", "หญิง (Female)"],
                colors: ["#6C5DD3", "#3DD9C1"],
                dataLabels: { enabled: false },
                plotOptions: {
                    pie: {
                        donut: {
                            size: "70%",
                            labels: {
                                show: true,
                                total: {
                                    show: true,
                                    label: "Total",
                                    fontSize: "15px",
                                    color: "#8F95B2",
                                    formatter: () => `${this.genderDistributionData.total}`,
                                },
                                value: {
                                    fontSize: "24px",
                                    fontWeight: 700,
                                    color: "#1B1D21",
                                },
                            },
                        },
                    },
                },
                legend: { show: false },
                stroke: { width: 3, colors: ["#fff"] },
            };
        },
        generationDistributionData() {
            let genXCount = 0;
            let genYCount = 0;
            let genZCount = 0;
            let babyBoomerCount = 0;
            HR.forEach(employee => {
                const gen = employee.generation;
                if (gen === "Gen X") {
                    genXCount++;
                } else if (gen === "Gen Y") {
                    genYCount++;
                } else if (gen === "Gen Z") {
                    genZCount++;
                } else if (gen === "Baby Boomer") {
                    babyBoomerCount++;
                }
            });
            return {
                genX: genXCount,
                genY: genYCount,
                genZ: genZCount,
                babyBoomer: babyBoomerCount,
                total: genXCount + genYCount + genZCount + babyBoomerCount
            };
        },
        generationSeries() {
            return [
                this.generationDistributionData.genX,
                this.generationDistributionData.genY,
                this.generationDistributionData.genZ,
                this.generationDistributionData.babyBoomer
            ];
        },
        generationOptions() {
            return {
                chart: {
                    type: "donut",
                    fontFamily: "Sarabun, sans-serif",
                },
                labels: ["Gen X", "Gen Y", "Gen Z", "Baby Boomer"],
                colors: ["#6C5DD3", "#3DD9C1", "#FF754C", "#FFD043"],
                dataLabels: { enabled: false },
                plotOptions: {
                    pie: {
                        donut: {
                            size: "70%",
                            labels: {
                                show: true,
                                total: {
                                    show: true,
                                    label: "Total",
                                    fontSize: "15px",
                                    color: "#8F95B2",
                                    formatter: () => `${this.generationDistributionData.total}`,
                                },
                                value: {
                                    fontSize: "24px",
                                    fontWeight: 700,
                                    color: "#1B1D21",
                                },
                            },
                        },
                    },
                },
                legend: { show: false },
                stroke: { width: 3, colors: ["#fff"] },
            };
        },
        nationalityDistributionData() {
            const targets = [
                "Thai", "American", "British", "German", "Canadian",
                "Australian", "Chinese", "Dutch", "Filipino", "French",
                "Indian", "Italian", "Japanese"
            ];
            const counts = {};
            targets.forEach(c => {
                counts[c] = { male: 0, female: 0, total: 0 };
            });

            HR.forEach(employee => {
                const nat = employee.nationality;
                const gender = employee.gender;
                if (targets.includes(nat)) {
                    counts[nat].total += 1;
                    if (gender === "Male") {
                        counts[nat].male += 1;
                    } else if (gender === "Female") {
                        counts[nat].female += 1;
                    }
                }
            });

            const categories = targets.map(c => {
                return `${c} (ชาย: ${counts[c].male} / หญิง: ${counts[c].female})`;
            });

            const seriesData = targets.map(c => counts[c].total);

            return {
                categories,
                seriesData
            };
        },
        nationalityOptions() {
            return {
                chart: {
                    id: "nationality-chart",
                    type: "bar",
                    toolbar: { show: false },
                    fontFamily: "Sarabun, sans-serif",
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: "65%",
                        borderRadius: 4,
                    },
                },
                dataLabels: {
                    enabled: true,
                    textAnchor: "start",
                    style: {
                        colors: ["#fff"],
                        fontSize: "11px",
                        fontFamily: "Sarabun, sans-serif",
                        fontWeight: "bold",
                    },
                    formatter: function (val) {
                        return val > 0 ? val : "";
                    },
                    offsetX: 0,
                },
                xaxis: {
                    categories: this.nationalityDistributionData.categories,
                    labels: {
                        style: { colors: "#8F95B2", fontSize: "11px" },
                    },
                    axisBorder: { show: false },
                    axisTicks: { show: false },
                },
                yaxis: {
                    labels: {
                        style: { colors: "#8F95B2", fontSize: "11px" },
                        maxWidth: 300,
                    },
                },
                grid: {
                    borderColor: "#F0F0F5",
                    xaxis: { lines: { show: true } },
                    yaxis: { lines: { show: false } },
                },
                colors: ["#6C5DD3"],
                legend: { show: false },
                tooltip: {
                    y: {
                        formatter: (val) => `${val} `,
                    },
                },
            };
        },
        nationalitySeries() {
            return [
                {
                    name: "Headcount",
                    data: this.nationalityDistributionData.seriesData
                }
            ];
        }
    },
    methods: {
    },
};
</script>

<style scoped>
/* ===== Dashboard Layout ===== */
.org-dashboard,
.org-dashboard>>>* {
    font-family: 'Sarabun', sans-serif !important;
}

.org-dashboard {
    padding: 24px 32px;
    background: #F7F8FC;
    min-height: 100vh;
}

/* ===== Header ===== */
.org-dashboard-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
    flex-wrap: wrap;
    gap: 12px;
}

.org-dashboard-title {
    font-size: 28px;
    font-weight: 700;
    color: #1B1D21;
    margin: 0;
    line-height: 1.3;
}

.org-header-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.org-header-date {
    font-size: 14px;
    color: #555770;
    font-weight: 500;
    background: #f5f6fa;
    padding: 6px 12px;
    border-radius: 8px;
    border: 1px solid #E4E4E4;
}

.org-date-picker {
    border-radius: 8px;
}

.org-period-select {
    min-width: 110px;
}

.org-header-btn {
    border-radius: 8px;
    border: 1px solid #E4E4E4;
    color: #555770;
    font-size: 13px;
    display: flex;
    align-items: center;
    gap: 5px;
}

/* ===== Stat Cards Grid ===== */
.org-stat-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
    margin-bottom: 24px;
}

@media (max-width: 1400px) {
    .org-stat-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 992px) {
    .org-stat-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 576px) {
    .org-stat-grid {
        grid-template-columns: 1fr;
    }
}

.org-stat-card {
    background: #fff;
    border-radius: 16px;
    padding: 20px 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    transition: box-shadow 0.25s, transform 0.25s;
}

.org-stat-card:hover {
    box-shadow: 0 6px 20px rgba(108, 93, 211, 0.10);
    transform: translateY(-2px);
}

.org-stat-card-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 14px;
}

.org-stat-icon-wrap {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
}

.org-stat-icon-staff {
    background: linear-gradient(135deg, #6C5DD3 0%, #8B7BE8 100%);
    color: #fff;
}

.org-stat-icon-thai {
    background: linear-gradient(135deg, #1890FF 0%, #69C0FF 100%);
    color: #fff;
}

.org-stat-icon-foreign {
    background: linear-gradient(135deg, #3DD9C1 0%, #5EECD5 100%);
    color: #fff;
}

.org-stat-icon-sections {
    background: linear-gradient(135deg, #FF754C 0%, #FF9A7C 100%);
    color: #fff;
}

.org-stat-icon-divisions {
    background: linear-gradient(135deg, #722ED1 0%, #B37FEB 100%);
    color: #fff;
}

.org-badge-blue {
    background: #E6F7FF;
    color: #1890FF;
}

.org-badge-orange {
    background: #FFF7E6;
    color: #FA8C16;
}

.org-badge-purple {
    background: #F9F0FF;
    color: #722ED1;
}

.org-stat-label {
    font-size: 15px;
    color: #8F95B2;
    font-weight: 500;
    flex: 1;
}

.org-stat-info {
    color: #C4C4CF;
    font-size: 14px;
    cursor: pointer;
}

.org-stat-value-wrap {
    display: flex;
    align-items: baseline;
    gap: 12px;
}

.org-stat-value {
    font-size: 32px;
    font-weight: 700;
    color: #1B1D21;
    line-height: 1.2;
}

.org-stat-badge {
    font-size: 12px;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    gap: 3px;
}

.org-badge-up {
    background: #E6FFF5;
    color: #00B37E;
}

.org-badge-down {
    background: #FFF1F0;
    color: #FF4D4F;
}

/* ===== Equal Height Rows ===== */
.org-chart-row,
.org-bottom-row {
    align-items: stretch !important;
}

.org-chart-row>>>.ant-col,
.org-bottom-row>>>.ant-col {
    display: flex;
    flex-direction: column;
}

/* ===== Chart Cards ===== */
.org-chart-row,
.org-bottom-row {
    margin-bottom: 4px;
}

.org-chart-card {
    background: #fff;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    transition: box-shadow 0.25s;
}

.org-chart-card:hover {
    box-shadow: 0 6px 20px rgba(108, 93, 211, 0.08);
}

.org-chart-card-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 16px;
    flex-wrap: wrap;
    gap: 10px;
}

.org-chart-title-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
}

.org-chart-title-icon {
    font-size: 16px;
    color: #6C5DD3;
}

.org-chart-title {
    font-size: 17px;
    font-weight: 600;
    color: #1B1D21;
}

.org-chart-big-value {
    font-size: 34px;
    font-weight: 700;
    color: #1B1D21;
    line-height: 1.2;
    margin-bottom: 6px;
}

.org-chart-sub {
    display: flex;
    align-items: center;
    gap: 8px;
}

.org-chart-sub-text {
    font-size: 13px;
    color: #8F95B2;
}

.org-chart-actions {
    display: flex;
    align-items: center;
    gap: 6px;
}

.org-chart-action-btn {
    border-radius: 8px;
    border: 1px solid #E4E4E4;
    color: #555770;
    font-size: 12px;
}

.org-period-select-sm {
    min-width: 95px;
}

/* ===== Distribution Stats ===== */
.org-distribution-stats {
    display: flex;
    gap: 24px;
    margin-bottom: 10px;
    flex-wrap: wrap;
}

.org-dist-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.org-dist-indicator {
    width: 4px;
    height: 18px;
    border-radius: 2px;
    display: inline-block;
    margin-bottom: 2px;
}

.org-dist-label {
    font-size: 14px;
    color: #8F95B2;
    font-weight: 500;
}

.org-dist-value {
    font-size: 22px;
    font-weight: 700;
    color: #1B1D21;
}

/* ===== Integration Table ===== */
.org-see-all {
    font-size: 13px;
    color: #6C5DD3;
    font-weight: 600;
    cursor: pointer;
}

.org-see-all:hover {
    color: #5046A5;
}

.org-app-cell {
    display: flex;
    align-items: center;
    gap: 12px;
}

.org-app-name {
    font-weight: 600;
    color: #1B1D21;
    font-size: 15px;
}

.org-rate-cell {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 140px;
}

.org-rate-bar-track {
    flex: 1;
    height: 5px;
    background: #E8E8EF;
    border-radius: 3px;
    overflow: hidden;
}

.org-rate-bar-fill {
    height: 100%;
    background: linear-gradient(90deg, #3B82F6, #6C5DD3);
    border-radius: 3px;
    transition: width 0.6s ease;
}

.org-rate-value {
    font-size: 14px;
    color: #8F95B2;
    font-weight: 500;
    min-width: 35px;
}

.org-profit-value {
    font-weight: 600;
    color: #1B1D21;
    font-size: 15px;
}

/* ===== Table Override ===== */
.org-integration-table>>>.ant-table-thead>tr>th {
    background: transparent;
    border-bottom: 1px solid #F0F0F5;
    font-size: 13px;
    font-weight: 600;
    color: #8F95B2;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 12px 16px;
}

.org-integration-table>>>.ant-table-tbody>tr>td {
    border-bottom: 1px solid #F7F8FC;
    padding: 14px 16px;
}

.org-integration-table>>>.ant-table-tbody>tr:hover>td {
    background: #F9F9FD;
}

/* ===== Staff Type Table ===== */
.org-staff-type-table {
    margin-top: 16px;
}

.org-staff-type-table>>>.ant-table-thead>tr>th {
    background: transparent;
    border-bottom: 1px solid #F0F0F5;
    font-size: 13px;
    font-weight: 600;
    color: #8F95B2;
    padding: 10px 8px;
}

.org-staff-type-table>>>.ant-table-tbody>tr>td {
    border-bottom: 1px solid #F7F8FC;
    padding: 12px 8px;
    font-size: 13px;
    font-weight: 500;
    color: #1B1D21;
}

.org-staff-type-table>>>.ant-table-tbody>tr:hover>td {
    background: #F9F9FD;
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
    .org-dashboard {
        padding: 16px;
    }

    .org-dashboard-title {
        font-size: 22px;
    }

    .org-stat-value {
        font-size: 22px;
    }

    .org-chart-big-value {
        font-size: 24px;
    }

    .org-distribution-stats {
        gap: 16px;
    }
}
</style>
